import React, { useMemo } from 'react';
import { config } from 'utils/config';
import { useRoutes } from 'hooks';
import ViewLink from '../ViewLink';
import styles from './styles.module.scss';
import { ProgramEnum } from '../../../../types/general';

const ResetDocument = (props: any) => {
  const routes = useRoutes();
  const resetDocuments = useMemo(
    () => [
      {
        type: 'link',
        title: 'Clinician Directions for Use',
        url: `${config.HYLIA_ASSETS_URL}/legal-content/reset/clinician-directions-for-use.pdf`,
      },
      {
        type: 'route',
        title: 'Lesson Summaries',
        url: routes.DOCUMENTS_LESSON_SUMMARIES,
      },
      {
        type: 'route',
        title: 'Lesson Content',
        url: routes.DOCUMENTS_LESSON_CONTENT,
      },
      {
        type: 'link',
        title: 'Lesson Worksheets',
        url: `${config.HYLIA_ASSETS_URL}/legal-content/reset/lesson-worksheets-en.pdf`,
        urlSpanish: `${config.HYLIA_ASSETS_URL}/legal-content/reset/lesson-worksheets-es.pdf`,
      },
    ],
    [routes],
  );
  return (
    <div data-testid="reset-document" className={styles.wrapper}>
      <div className={styles['document-logo-reset']} />
      <div className={styles['document-items']}>
        {resetDocuments.map((item) => (
          <div
            key={item.title}
            data-testid="reset-document-item"
            className={styles['document-link']}
          >
            <p className={styles['link-title']}>{item.title}</p>
            {item.title === 'Clinician Directions for Use' ? (
              <ViewLink
                item={item}
                history={props.history}
                program={ProgramEnum.RESET}
                text="View"
                locale="en"
              />
            ) : (
              <>
                <ViewLink
                  item={item}
                  history={props.history}
                  program={ProgramEnum.RESET}
                  text="English"
                  locale="en"
                />
                <ViewLink
                  item={item}
                  history={props.history}
                  program={ProgramEnum.RESET}
                  text="Spanish"
                  locale="es"
                />
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResetDocument;
